import { render, staticRenderFns } from "./VideoControler.vue?vue&type=template&id=18c1daf1&scoped=true"
import script from "./VideoControler.vue?vue&type=script&lang=js"
export * from "./VideoControler.vue?vue&type=script&lang=js"
import style0 from "./VideoControler.vue?vue&type=style&index=0&id=18c1daf1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c1daf1",
  null
  
)

export default component.exports